import highEmphasis from '../../../text/high-emphasis';

const primary = (params) => highEmphasis(params);

export default primary;
